<template>
	<div class="relative flex flex-col gap-1">
		<template v-if="chatStore.chatListIsLoading">
			<!-- Loading -->
			<div
				class="absolute inset-0 grid place-items-center bg-white/70 rounded-full"
			>
				<Spinner class="size-8 text-primary"></Spinner>
			</div>
		</template>
		<template v-else>
			<template v-if="!renderedList.length">
				<!-- Chat list empty -->
				<div class="text-center p-5">Zatím zde nejsou žádné chaty</div>
			</template>
			<template v-else>
				<!-- Chat list items -->
				<TransitionGroup name="items-list">
					<div v-for="chatItem in renderedList" :key="chatItem.channelId">
						<ChatListItem :item="chatItem"></ChatListItem>
					</div>
				</TransitionGroup>
			</template>
		</template>
	</div>
</template>

<script setup lang="ts">
import Spinner from '@/assets/icons/spinner.svg'
import ChatListItem from '@/components/ChatListItem.vue'
import { useChatStore } from '@/stores/chatStore'
const chatStore = useChatStore()
import { computed, onMounted, onUnmounted, ref } from 'vue'

const refetchInterval = ref<ReturnType<typeof setInterval> | null>(null)
const REFETCH_INTERVAL_SECONDS = 30 // refetch list interval in seconds

onMounted(() => {
	chatStore.fetchChannelList(true)

	refetchInterval.value = setInterval(() => {
		// set refetch after interval
		chatStore.fetchChannelList(false)
	}, REFETCH_INTERVAL_SECONDS * 1000)
})

onUnmounted(() => {
	if (refetchInterval.value) {
		clearInterval(refetchInterval.value)
	}

	chatStore.chatList = []
})

/**
 * sorted and filtered chat list
 */
const renderedList = computed(() => {
	return chatStore.chatListByViewMode.sort((a, b) => {
		const timeA = Date.parse(a.lastMessageDateTime ?? '') || 0
		const timeB = Date.parse(b.lastMessageDateTime ?? '') || 0
		return timeB - timeA
	})
})
</script>

<style scoped></style>
